import { pxToRem } from '@packages/themes/utils';
import { makeStyles } from '../styles/tss-react';

export interface PaperStyleProps {
  borderWidth?: number;
}

const useStyles = makeStyles<PaperStyleProps>({ name: 'Paper' })(
  ({ palette, spacing, shape }, { borderWidth }) => ({
    root: {
      padding: spacing(2),
      backgroundColor: palette.semantic.bg.layer1,
      borderRadius: shape.borderRadius,
    },
    glow: {
      borderRadius: 8,
      border: '1px solid transparent',
      backgroundImage: [
        `linear-gradient(${palette.semantic.bg.layer1}, ${palette.semantic.bg.layer1})`,
        palette.semantic.gradients.paperGlow,
      ].join(', '),
      backgroundSize: 'auto, 280% 280%',
      backgroundPosition: '0 0, 0% 50%',
      backgroundOrigin: 'border-box',
      backgroundClip: 'padding-box, border-box',
      boxShadow: `4px 4px 32px 0 ${palette.semantic.boxShadow.glowColor}`,
      transition: 'background-position 0.5s ease-in-out',
    },
    glowBorderWidth: {
      borderWidth: borderWidth === undefined ? undefined : pxToRem(borderWidth),
    },
  })
);

export default useStyles;
